import { VideoPlayer, Image, OptionalSiteLinkWrapper } from 'components/shared';
import { gtmClickElementIds, trackEvents, trackInWindow } from 'hooks/tracking/track';

const GridBanner = ({ className = '', style, banner }) => {
  const trackGridBannerClick = () => {
    trackInWindow({
      event: trackEvents.componentGridBannerClick,
      page_path: window.location.pathname,
      page_title: document.title,
      component_banner: banner.name,
      component_title: banner.title,
    });
  };

  return (
    <article style={style} className={`relative w-full overflow-hidden ${className}`}>
      <OptionalSiteLinkWrapper
        id={`${gtmClickElementIds.componentGridBanner} ~ ${banner.link.name}`}
        link={banner.link}
        event="Grid banner clicked"
        className="absolute left-0 top-0 block h-full w-full"
        onClick={trackGridBannerClick}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            trackGridBannerClick();
          }
        }}
      >
        <div
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              trackGridBannerClick();
            }
          }}
          onClick={trackGridBannerClick}
          className="pointer-events-none absolute left-0 top-0 flex h-full w-full items-center justify-center bg-[#E7EDF1] "
        >
          {banner.videoUrl ? (
            <VideoPlayer
              videoURL={banner.videoUrl}
              className="h-full w-full"
              videoClassName="absolute"
            />
          ) : (
            <Image src={banner.image} layout="fill" />
          )}
        </div>
        <div className="pointer-events-none absolute left-0 top-0 flex h-full w-full flex-col items-center justify-center p-[16px] text-white">
          {banner.title && (
            <h2 className="pointer-events-none max-w-[80%] text-center font-nimbus-sans-extd-d text-[35px] font-bold uppercase leading-[0.9]">
              {banner.title}
            </h2>
          )}
          {banner.link && (
            <p className="pointer-events-none mt-[20px] font-nimbus-sans-extd-d text-[12px] uppercase underline">
              {banner.link.text}
            </p>
          )}
        </div>
      </OptionalSiteLinkWrapper>
    </article>
  );
};

export default GridBanner;
